<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36 20h-2.5v-3.5a9.5 9.5 0 00-19 0V20H12a2 2 0 00-2 2v17a2 2 0 002 2h24a2 2 0 002-2V22a2 2 0 00-2-2zm-18.5-3.5a6.5 6.5 0 0113 0V20h-13zM35 38H13V23h22z"/><path d="M28.64 26.08l-6.11 6.21-3.2-3a1 1 0 00-1.33 1.5l3.92 3.63a1 1 0 00.68.27 1 1 0 00.71-.3l6.8-6.91a1 1 0 00-1.43-1.4z"/></svg>